import { render, staticRenderFns } from "./TaskListModal.vue?vue&type=template&id=5c495a3d&scoped=true"
import script from "./TaskListModal.vue?vue&type=script&lang=js"
export * from "./TaskListModal.vue?vue&type=script&lang=js"
import style0 from "./TaskListModal.vue?vue&type=style&index=0&id=5c495a3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c495a3d",
  null
  
)

export default component.exports